import { OrderedMap } from 'immutable';
import BookmarkConstants from '../constants/BookmarkConstants';
import BookmarkStore from '../stores/BookmarkStore';
import InventoryRecord from '../models/InventoryRecord';

const isBrowser = (typeof window !== 'undefined');

const BookmarkActions = {
  list(context, payload) {
    payload.pagination = payload.pagination || BookmarkStore.defaultPagination;
    payload.filters = payload.filters || [];

    if(context.getCurrentStore()) {
      payload.filters.push({type: 'store_id', value: context.getCurrentStore().id});
    }

    let requestPayload = {
      filters: payload.filters,
      pagination: payload.pagination
    };

    context.dispatch(BookmarkConstants.LIST_BOOKMARKS_START, payload);

    return context
      .delectoryApi
      .bookmarks
      .list(requestPayload)
      .then(responsePayload => {
        let inventoryRecords = responsePayload.inventory_records.reduce((map, inventoryRecord) => {
          // NOTE: bookmark records aren't currently being serialized
          return map.set(inventoryRecord.id, new InventoryRecord(inventoryRecord));
        }, new OrderedMap());
        payload.pagination.totalResults = responsePayload.total_results;
        context.dispatch(BookmarkConstants.LIST_BOOKMARKS_SUCCESS, {
          entities: inventoryRecords,
          filters: payload.filters,
          pagination: payload.pagination
        });
      })
      .catch(err => {
        context.dispatch(BookmarkConstants.LIST_BOOKMARKS_FAILURE, {error: err});
      });
  },
  // NOTE: /bookmarks/create doesn't return InventoryRecord so passing through in payload
  create(context, payload) {
    let id = payload.inventoryRecord.id;
    context.dispatch(BookmarkConstants.CREATE_BOOKMARK_START, id);

    let requestPayload = {inventory_record_id: id};

    return context
      .delectoryApi
      .bookmarks
      .create(requestPayload)
      .then(responsePayload => {
        // NOTE: responsePayload is empty
        context.dispatch(BookmarkConstants.CREATE_BOOKMARK_SUCCESS, {
          inventoryRecord: payload.inventoryRecord.setIn(['customer_context', 'bookmarked'], true),
          collectionId: payload.collectionId
        });
        context.trackEvent('Product Added to Wishlist', {
          wishlist_id: context.delectoryApi._session_key, // Using customer_id for wishlist id
          product_id: payload.inventoryRecord.id,
          name: payload.inventoryRecord.name,
          brand: payload.inventoryRecord.brand,
          price: payload.inventoryRecord.current_price
        });
        return null;
      })
      .catch(err => {
        context.dispatch(BookmarkConstants.CREATE_BOOKMARK_FAILURE, {error: err, entityId: id});
        return null;
      });
  },
  // NOTE: /bookmarks/create doesn't return InventoryRecord so passing through in payload
  delete(context, payload, done) {
    let id = payload.inventoryRecord.id;
    context.dispatch(BookmarkConstants.DELETE_BOOKMARK_START, id);

    let requestPayload = {inventory_record_id: id};

    return context
      .delectoryApi
      .bookmarks
      .delete(requestPayload)
      .then(responsePayload => {
        // NOTE: responsePayload is empty
        context.dispatch(BookmarkConstants.DELETE_BOOKMARK_SUCCESS, {
          inventoryRecord: payload.inventoryRecord.setIn(['customer_context', 'bookmarked'], false),
          collectionId: payload.collectionId
        });
        context.trackEvent('Product Removed from Wishlist', {
          wishlist_id: context.delectoryApi._session_key, // Using customer_id for wishlist id
          product_id: payload.inventoryRecord.id,
          name: payload.inventoryRecord.name,
          brand: payload.inventoryRecord.brand,
          price: payload.inventoryRecord.current_price
        });
        return null;
      })
      .catch(err => {
        context.dispatch(BookmarkConstants.DELETE_BOOKMARK_FAILURE, {error: err, entityId: id});
        return null;
      });
  }
};

export default BookmarkActions;



// WEBPACK FOOTER //
// banquet/actions/BookmarkActions.js